import React from 'react'
import cn from 'classnames'
import styles from './VNLoader.module.scss'
import ConnectingIndicator from '../../components/ConnectingIndicator'

const VNLoader = ({
  transparent = false,
  standalone = false,
  isSidebarLoading = false,
  processing = false,
  text = null,
  className = null,
  isKiosk = false,
}) => {
  if (isKiosk) {
    return (
      <ConnectingIndicator
        className={className}
        isSidebarLoading={isSidebarLoading || processing}
        transparent={transparent || processing}
        position={standalone || processing ? 'relative' : 'absolute'}
        isKiosk={isKiosk}
      />
    )
  }

  const classes = cn(styles.overlay, {
    [styles.transparent]: transparent,
    [styles.sidebar]: isSidebarLoading,
    [styles.standalone]: standalone,
    [styles.processing]: processing,
  })

  return (
    <div className={classes}>
      <div className={styles.container}>
        <div className={styles.ring}></div>
        <div className={styles.wrapper}>
          <div className={styles.circle}></div>
          <div className={styles.gradient}></div>
          <div className={styles.punchout}></div>
        </div>
      </div>
      {text && <span className={styles.text}>{text}</span>}
    </div>
  )
}

export default VNLoader
